import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { LocalizationService } from '../../../../services/localization.service';
import { MatDialog } from '@angular/material/dialog';
import { TimeSlotCalendarPopupComponent } from '../time-slot-calendar-popup/time-slot-calendar-popup.component';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { CalendarService } from '../../services/calendar.service';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DisplayDateFormatEnum } from '../../models/display-date-format-enum';

@Component({
  selector: 'app-time-slot-date-selector',
  templateUrl: './time-slot-date-selector.component.html',
  styleUrls: ['./time-slot-date-selector.component.css']
})
export class TimeSlotDateSelectorComponent implements OnInit, OnDestroy {

  faCaretLeft = faCaretLeft;
  faCaretRight = faCaretRight;

  @Input() selectedDate: Date;
  @Input() calendarService: CalendarService;
  @Input() displayDateFormat: DisplayDateFormatEnum = DisplayDateFormatEnum.defaultDisplayDate;

  @Input()
  showSelectDateDialog = true;

  @Output() nextDayClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() prevDayClick: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  updatedBookingSlotEvent: EventEmitter<any> = new EventEmitter<any>();
  private updatedBookingSlotEventSubscription: Subscription;

  constructor(
    private localizationService: LocalizationService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeCloseDialogSubscription();
  }

  public get displaySelectedDate(): string {
    if (this.displayDateFormat === DisplayDateFormatEnum.shotWeekdayAndDate) {
      return this.localizationService.formatDateToShotWeekdayAndDate(this.selectedDate);
    }
    return this.localizationService.formatDate(this.selectedDate);
  }

  public selectDateClick(): void {
    if (!this.showSelectDateDialog) {
      return;
    }

    this._unsubscribeCloseDialogSubscription();
    const dialogRef = this.dialog.open(TimeSlotCalendarPopupComponent, {
      data: {
        calendarService: this.calendarService
      }
    });

    this.updatedBookingSlotEventSubscription = dialogRef.componentInstance.updatedBookingSlotEvent.subscribe(
      () => {
        this.updatedBookingSlotEvent.emit();
      });
  }

  _unsubscribeCloseDialogSubscription(): void {
    if (this.updatedBookingSlotEventSubscription) {
      this.updatedBookingSlotEventSubscription.unsubscribe();
      this.updatedBookingSlotEventSubscription = null;
    }
  }

  private get _today(): Date {
    return new Date();
  }

  get canBackwardDay(): boolean {
    const today = this._today;
    const selectedDate = new Date(this.selectedDate);
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    return selectedDate > today;
  }

  onNextDay(): void {
    this.nextDayClick.emit();
  }

  onPrevDay(): void {
    this.prevDayClick.emit();
  }
}
